import { useEffect } from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { trackPhoneConversion } from "../utils/tracking";

const PHONE = "+359876995651";
const PHONE_DISPLAY = "Обадете се";
const EMAIL = "rangelovkomrs@gmail.com";

const contactCards = [
{ icon: Phone, title: "Телефон", value: "+359 876 995 651", href: `tel:${PHONE}`, label: null, testId: "contact-phone" },
{ icon: Mail, title: "Имейл", value: EMAIL, href: `mailto:${EMAIL}`, label: null, testId: "contact-email" },
{ icon: MapPin, title: "Работен район", value: "София и София-област", href: null, label: null, testId: "contact-area" },
{ icon: Clock, title: "Работно време", value: "7:00 – 22:00, всеки ден", href: null, label: null, testId: "contact-hours" }];


export default function KontaktiPage() {
  useEffect(() => {
    document.title = "Контакти | Свържете се с нас — Хамали София";
    const setMeta = (name, content, property = false) => {
      const attr = property ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url) => {
      let el = document.querySelector('link[rel="canonical"]');
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    setMeta("description", "Свържете се с Хамали София за безплатна оферта. Работим всеки ден от 7:00 до 22:00. Телефон: +359 876 995 651. Обслужваме цяла София и областта.");
    setMeta("og:title", "Контакти | Свържете се с нас — Хамали София", true);
    setMeta("og:description", "Обадете се на Хамали София за безплатна консултация и оферта. Работим 7 дни в седмицата от 7:00 до 22:00. Бърз отговор гарантиран.", true);
    setMeta("og:url", "https://hamalski-sofia.com/kontakti", true);
    setCanonical("https://hamalski-sofia.com/kontakti");
  }, []);

  return (
    <div style={{ backgroundColor: "#FFFFFF", paddingTop: "68px" }}>

      {/* HEADER — light */}
      <section data-testid="kontakti-header" style={{ padding: "5rem 1.25rem 3rem", maxWidth: "900px", margin: "0 auto", textAlign: "center" }}>
        <p style={{ color: "#2dcf0c", fontSize: "0.8rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "0.875rem" }}>Свържете се с нас</p>
        <h1 data-testid="kontakti-h1" style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(2rem, 5vw, 3.75rem)", lineHeight: 1.08, letterSpacing: "-0.02em", color: "#0A0A0A", textTransform: "uppercase", marginBottom: "1.25rem" }}>
          Свържете се с Нас за{" "}
          <span style={{ color: "#2dcf0c" }}>Оферта</span>
        </h1>
        <p style={{ color: "#6B7280", fontSize: "1rem", lineHeight: 1.7, maxWidth: "560px", margin: "0 auto 2rem" }}>
          Обадете се или напишете имейл за безплатна консултация и ценова оферта. Работим всеки ден от 7:00 до 22:00.
        </p>
        <a href={`tel:${PHONE}`} data-testid="kontakti-hero-call-btn" className="btn-call" style={{ padding: "1rem 2.25rem", fontSize: "1.05rem", borderRadius: "4px" }} onClick={trackPhoneConversion}>
          <Phone size={20} />
          <span>Обадете се</span>
        </a>
      </section>

      {/* CONTACT CARDS — light grey bg */}
      <section data-testid="kontakti-cards" style={{ padding: "0 1.25rem 4rem", maxWidth: "1280px", margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "1.25rem" }}>
          {contactCards.map((card) => {
            const Icon = card.icon;
            return (
              <div key={card.title} data-testid={card.testId}
              style={{ padding: "2rem", backgroundColor: "#F8F8FA", border: "1px solid rgba(0,0,0,0.08)", borderRadius: "8px", boxShadow: "0 2px 16px rgba(0,0,0,0.05)", transition: "box-shadow 0.25s ease, border-color 0.25s ease" }}
              onMouseEnter={(e) => {e.currentTarget.style.boxShadow = "0 4px 24px rgba(45,207,12,0.1)";e.currentTarget.style.borderColor = "rgba(45,207,12,0.25)";}}
              onMouseLeave={(e) => {e.currentTarget.style.boxShadow = "0 2px 16px rgba(0,0,0,0.05)";e.currentTarget.style.borderColor = "rgba(0,0,0,0.08)";}}>
                <div style={{ width: 48, height: 48, backgroundColor: "rgba(45,207,12,0.08)", border: "1px solid rgba(45,207,12,0.2)", borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "1.25rem" }}>
                  <Icon size={20} color="#2dcf0c" />
                </div>
                <p style={{ color: "#9CA3AF", fontSize: "0.75rem", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "0.5rem" }}>{card.title}</p>
                {card.href ?
                <a href={card.href} data-testid={`${card.testId}-link`}
                style={{ display: "block", color: "#0A0A0A", textDecoration: "none", fontSize: "1rem", fontWeight: 700, fontFamily: "Montserrat, sans-serif", marginBottom: card.label ? "1rem" : 0, transition: "color 0.2s ease" }}
                onMouseEnter={(e) => {e.target.style.color = "#2dcf0c";}}
                onMouseLeave={(e) => {e.target.style.color = "#0A0A0A";}} className="!text-[#0A0A0A]">
                    {card.value}
                  </a> :

                <p style={{ color: "#0A0A0A", fontSize: "1rem", fontWeight: 700, fontFamily: "Montserrat, sans-serif", marginBottom: 0 }}>{card.value}</p>
                }
                {card.label && card.href &&
                <a href={card.href} className="btn-call" data-testid={`${card.testId}-action-btn`}
                style={{ padding: "0.625rem 1.25rem", fontSize: "0.85rem", borderRadius: "4px", marginTop: "0.75rem", display: "inline-flex", alignItems: "center", gap: "0.375rem" }}>
                    <Icon size={14} />
                    <span>{card.label}</span>
                  </a>
                }
              </div>);

          })}
        </div>
      </section>

      {/* MAP */}
      <section data-testid="kontakti-map" style={{ padding: "0 1.25rem 5rem", maxWidth: "1280px", margin: "0 auto" }}>
        <div style={{ backgroundColor: "#FFFFFF", border: "1px solid rgba(0,0,0,0.08)", borderRadius: "8px", overflow: "hidden", boxShadow: "0 2px 20px rgba(0,0,0,0.07)" }}>
          <div style={{ padding: "1.25rem 1.5rem", borderBottom: "1px solid rgba(0,0,0,0.06)", display: "flex", alignItems: "center", gap: "0.625rem" }}>
            <MapPin size={16} color="#2dcf0c" />
            <span style={{ color: "#374151", fontSize: "0.875rem", fontWeight: 600 }}>Обслужваме — София и София-област</span>
          </div>
          <iframe data-testid="google-map-iframe" title="Хамали София — Google Карта"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d186953.86490736043!2d23.1993836!3d42.6954115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa8682cb317bf5%3A0x400a01269bf5e10!2sSofia%2C%20Bulgaria!5e0!3m2!1sen!2sbg!4v1700000000000!5m2!1sen!2sbg"
          width="100%" height="420"
          style={{ border: "none", display: "block" }}
          allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        </div>
      </section>

      {/* BOTTOM CTA */}
      <section data-testid="kontakti-cta" style={{ padding: "4rem 1.25rem", textAlign: "center", backgroundColor: "#F0FDF4", borderTop: "1px solid rgba(45,207,12,0.2)" }}>
        <h2 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(1.5rem, 3.5vw, 2.5rem)", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.02em", marginBottom: "1rem" }}>
          Готови ли сте? <span style={{ color: "#2dcf0c" }}>Обадете се сега!</span>
        </h2>
        <p style={{ color: "#6B7280", marginBottom: "2rem", fontSize: "1rem" }}>
          Безплатна консултация и оценка. Работим всеки ден — <strong style={{ color: "#0A0A0A" }}>7:00 до 22:00</strong>.
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", justifyContent: "center" }}>
          <a href={`tel:${PHONE}`} data-testid="kontakti-cta-call-btn" className="btn-call" style={{ padding: "1rem 2rem", fontSize: "1rem", borderRadius: "4px" }} onClick={trackPhoneConversion}>
            <Phone size={20} />
            <span>{PHONE_DISPLAY}</span>
          </a>
          <a href={`mailto:${EMAIL}`} data-testid="kontakti-cta-email-btn"
          style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem", padding: "1rem 2rem", border: "2px solid rgba(0,0,0,0.2)", color: "#0A0A0A", textDecoration: "none", fontSize: "0.95rem", fontFamily: "Montserrat, sans-serif", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.04em", borderRadius: "4px", transition: "border-color 0.2s ease" }}
          onMouseEnter={(e) => {e.currentTarget.style.borderColor = "rgba(0,0,0,0.5)";}}
          onMouseLeave={(e) => {e.currentTarget.style.borderColor = "rgba(0,0,0,0.2)";}}>
            <Mail size={18} />
            <span>{EMAIL}</span>
          </a>
        </div>
      </section>
    </div>);

}